import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const BudgeUnreadIcon = ({ size, deg, e2eId, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg, "data-e2e-id": e2eId },
    React.createElement("rect", { width: "13", height: "13", x: "3.5", y: "3.5", fill: "#E68173", fillRule: "evenodd", stroke: "#FFF", rx: "6.5" })));
export const BudgeUnread = iconGenerator(BudgeUnreadIcon);
//# sourceMappingURL=BudgeUnread.js.map